import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    height: -webkit-fill-available;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: center;
      flex-direction: column;
    }
  `}
`;

export const ButtonBackWrapper = styled.div`
  position: absolute;
  left: 32px;
  top: 32px;
  z-index: 10;
`;

export const PromoPanel = styled.div`
  ${({ theme }) => css`
    align-items: flex-end;
    background-image: ${theme.v2.colors.gradient.tertiary};
    background-size: cover;
    border-radius: 0 120px 0 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 40px;
    padding-top: 120px;
    position: relative;
    width: 45%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: center;
      border-radius: 0 0 120px 0;
      padding: 0;
      padding-top: 0;
      width: 100%;
    }
  `};
`;

export const PromoPanelInner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
`;

export const PromoTitleContainer = styled.div`
  ${({ theme }) => css`
    margin: 0 0 32px;
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
      padding: 28px 0;
    }
  `}
`;

export const PromoTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    text-align: center;

    @media (min-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }

    @media (min-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }
    
    @media (min-width: ${theme.v2.breakpoints.lg}) {
      font-size: 28px;
    }
  `};
`;

export const PromoImage = styled.img`
  ${({ theme }) => css`
    max-width: 715px;
    user-select: none;
    -webkit-user-drag: none;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `};
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    bottom: -183px;
    left: -134px;
    max-width: 410px;
    position: absolute;
    user-select: none;
    -webkit-user-drag: none;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const FormContainer = styled.div`
  ${({ theme }) => css`
    padding: 48px 40px;
    overflow: hidden;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px 20px;
      overflow: auto;
    }
  `};
`;

export const FormContent = styled.div`
  min-height: -webkit-fill-available;
`;
